import React, { useState, useEffect, useRef } from 'react';
import Header from '../../components/Header';
import './index.css';
import api from '../../services/api_despesas';
import { parse, addDays } from 'date-fns';
import { format } from 'date-fns-tz';
import { mask, unMask } from 'remask';
import { CSVLink, CSVDownload } from "react-csv";

export default function Status() {

    const [ordem, setOrdem] = useState({
        items: [
            { id: 0, text: "MATRICULA" },
            { id: 1, text: "NOME" },
            { id: 2, text: "INICIO" },
            { id: 3, text: "STATUS" },
        ],
        selectItem: 0
    });

    const [status, setStatus] = useState({
        items: [
            { id: 0, text: "TODOS" },
            { id: 1, text: "EM FÉRIAS" },
            { id: 2, text: "AGUARDANDO FÉRIAS" },
            { id: 3, text: "FÉRIAS CONCUIDAS" },
            { id: 4, text: "SEM FÉRIAS CADASTRADAS" },
        ],
        selectItem: 0
    });

    const [ferias, setFerias] = useState([]);
    const [dataIni, setDataIni] = useState('');
    const [dataFim, setDataFim] = useState('');
    const [matricula, setMatricula] = useState('');
    const [nome, setNome] = useState('');

    const tableRef = useRef(null);
    useEffect(() => {
        buscaDados();
    }, []);

    function buscaDados() {
        var filtros = '';


        if (filtros === '') {
            filtros = '?ordem=' + ordem.selectItem;
        } else {
            filtros = filtros + '&ordem=' + ordem.selectItem;
        }

        if (status.selectItem !== '0') {
            if (filtros === '') {
                filtros = '?status=' + status.selectItem;
            } else {
                filtros = filtros + '&status=' + status.selectItem;
            }
        }
        if (dataIni !== null && dataIni !== '') {
            if (filtros === '') {
                filtros = '?dataini=' + format(parse(dataIni, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd', { timeZone: 'America/Sao_Paulo' });
            } else {
                filtros = filtros + '&dataini=' + format(parse(dataIni, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd', { timeZone: 'America/Sao_Paulo' });

            }
        }
        if (dataFim !== null && dataFim !== '') {
            if (filtros === '') {
                filtros = '?datafim=' + format(parse(dataFim, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd', { timeZone: 'America/Sao_Paulo' });
            } else {
                filtros = filtros + '&datafim=' + format(parse(dataFim, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd', { timeZone: 'America/Sao_Paulo' });
            }
        }

        if (nome !== null && nome !== '') {
            if (filtros === '') {
                filtros = '?nome=' + nome;
            } else {
                filtros = filtros + '&nome=' + nome;
            }
        }

        if (matricula !== null && matricula !== '') {
            if (filtros === '') {
                filtros = '?mat=' + matricula;
            } else {
                filtros = filtros + '&mat=' + matricula;
            }
        }
        api.get(`/ferias${filtros}`).then(function (response) {
            if (response.data) {
                setFerias(response.data);
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });

    }

    function renderStatusFerias(item) {
        if (item.status === 1) {
            return (
                <td>EM FÉRIAS</td>
            )
        } else if (item.status === 2) {
            return (
                <td>AGUARDANDO FÉRIAS</td>
            )
        } else if (item.status === 3) {
            return (
                <td>FÉRIAS CONCLUIDAS</td>
            )
        } else {
            return (
                <td>SEM FÉRIAS CADASTRADAS</td>
            )
        }
    }

    function RenderFerias() {
        return (
            ferias.map((item, index) => {
                return (
                    <tr>
                        <td>{item.matricula}</td>
                        <td>{item.nome}</td>
                        {renderStatusFerias(item)}
                        <td>{item.dias_abono}</td>
                        <td>{item.dias_gozo}</td>
                        <td>{
                            item.data_inicio ? format(new Date(item.data_inicio), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' }) : ''}
                        </td>
                        <td>
                            {item.data_inicio ? format(addDays(new Date(item.data_inicio), item.dias_gozo), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' }) : ''}
                        </td>
                    </tr>
                )
            })
        )
    }

    function handleMaskData(value) {
        const originalValue = unMask(value);
        const maskedValue = mask(originalValue, [
            "9", "99", "99/9", "99/99", "99/99/9", "99/99/99", "99/99/999", "99/99/9999",
        ]);
        return maskedValue;
    }

    function handleSelectOrdem(value) {
        const novaordem = Object.assign([], ordem);
        novaordem.selectItem = value;
        setOrdem(novaordem);
    }

    function handleSelectStatus(value) {
        const novostatus = Object.assign([], status);
        novostatus.selectItem = value;
        setStatus(novostatus);
    }

    return (
        <div className="container-lg">
            <Header title="STATUS DE FÉRIAS" />
            <div className="filtros">
                <div className="content form">
                    <div className="column-ferias">
                        <label>ORDENAR POR:</label>
                        <select
                            className="col-md-12 combobox-ferias edit form-control"
                            id="tipo"
                            value={ordem.selectItem}
                            onChange={(e) => handleSelectOrdem(e.target.value)}
                        // ref={tipoRef}
                        // onKeyDown={(e) => handledown(e, etapaRef)}
                        >
                            {ordem.items.map((item, index) => (
                                <option key={index} value={item.id}>{item.text}</option>
                            ))}
                        </select>
                    </div>
                    <div className="column-ferias">
                        <label>MATRÍCULA:</label>
                        <input
                            type="text"
                            id="dataini"
                            // ref={dataIniRef}
                            value={matricula}
                            className="form-control edit"
                            placeholder="MATRICULA"
                            // onKeyDown={(e) => handledown(e, dataFimRef)}
                            onChange={(e) => setMatricula(e.target.value)}
                        />
                    </div>
                    <div className="column-nome-ferias">
                        <label>NOME:</label>
                        <input
                            type="text"
                            id="dataini"
                            // ref={dataIniRef}
                            value={nome}
                            className="form-control edit"
                            placeholder="NOME"
                            // onKeyDown={(e) => handledown(e, dataFimRef)}
                            onChange={(e) => setNome(e.target.value)}
                        />
                    </div>
                    <div className="column-ferias">
                        <label>DT. INI.:</label>
                        <input
                            type="text"
                            id="dataini"
                            // ref={dataIniRef}
                            value={dataIni}
                            className="form-control edit"
                            placeholder="DATA INICIAL"
                            // onKeyDown={(e) => handledown(e, dataFimRef)}
                            onChange={(e) => setDataIni(handleMaskData(e.target.value))}
                        />
                    </div>
                    <div className="column-ferias">
                        <label>DT. FIM:</label>
                        <input
                            type="text"
                            id="dataini"
                            // ref={dataIniRef}
                            value={dataFim}
                            className="form-control edit"
                            placeholder="DATA FINAL"
                            // onKeyDown={(e) => handledown(e, dataFimRef)}
                            onChange={(e) => setDataFim(handleMaskData(e.target.value))}
                        />
                    </div>
                    <div className="column-status-ferias">
                        <label>STATUS:</label>
                        <select
                            className="col-md-12 combobox-ferias edit form-control"
                            id="tipo"
                            value={status.selectItem}
                            onChange={(e) => handleSelectStatus(e.target.value)}
                        // ref={tipoRef}
                        // onKeyDown={(e) => handledown(e, etapaRef)}
                        >
                            {status.items.map((item, index) => (
                                <option key={index} value={item.id}>{item.text}</option>
                            ))}
                        </select>
                    </div>
                    <div className="column-buttom-ferias">
                        <input className="btn-ferias btn btn-primary" type="button" value="FILTRAR" onClick={() => buscaDados()} />
                    </div>
                    <div className="column-buttom-ferias">
                        <CSVLink
                            data={ferias}
                            separator={";"}
                            className=" btn-ferias btn btn-success"
                        >
                            Download
                        </CSVLink>
                    </div>
                </div>
                <div className="content form">

                </div>
            </div>
            <table className="table table-sm" id="table-to-xls" ref={tableRef}>
                <thead>
                    <tr>
                        <th>MAT.</th>
                        <th>NOME</th>
                        <th>STATUS</th>
                        <th>ABONO</th>
                        <th>DIAS</th>
                        <th>INICIO</th>
                        <th>FIM</th>
                    </tr>
                </thead>
                <tbody>
                    {RenderFerias()}
                </tbody>
            </table>
        </div>
    )
}